import { Stack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiFileText, FiMessageSquare } from "react-icons/fi";
import {
  PublicBidStatus,
  type BuyerPublicBidDetailDto,
} from "../../../../autogen/bff-api";
import { useDisplayDateWithTime } from "../../../../common/formatting/useDisplayDateWithTime";
import { TipTap } from "../../../../common/input/TipTap/TipTap";
import { LabelValueGrid } from "../../../sourcing-events/portal/view-single/LabelValueGrid";
import { SectionCard } from "../../../sourcing-events/portal/view-single/SectionCard";
import { BID_DETAIL_DASH, getBidContactSummary } from "./bidContact";
import { RejectionDetailsSection } from "./BidRejectionSummary";

interface Props {
  detail: BuyerPublicBidDetailDto;
}

export const OverviewTab = ({ detail }: Props) => {
  const { t } = useTranslation();
  const displayDateTime = useDisplayDateWithTime();
  const { bid } = detail;

  const contact = getBidContactSummary(detail, t("more"));
  const infoRows = [
    {
      label: t("Supplier"),
      value: detail.ownerName?.trim() || BID_DETAIL_DASH,
    },
    { label: t("Organization number"), value: contact.organizationNumber },
    { label: t("Contact person"), value: contact.contactName },
    { label: t("Email"), value: contact.email },
    ...(contact.phone !== BID_DETAIL_DASH
      ? [{ label: t("Phone"), value: contact.phone }]
      : []),
    {
      label: t("Submitted"),
      value: bid.submittedAt
        ? displayDateTime(bid.submittedAt)
        : BID_DETAIL_DASH,
    },
  ];

  return (
    <Stack spacing="6">
      {bid.status === PublicBidStatus.Rejected ? (
        <RejectionDetailsSection detail={detail} />
      ) : null}

      <SectionCard icon={FiFileText} title={t("Bid information")}>
        <LabelValueGrid rows={infoRows} />
      </SectionCard>

      {bid.coverLetter && (
        <SectionCard icon={FiMessageSquare} title={t("Cover letter")}>
          <TipTap
            content={bid.coverLetter}
            editable={false}
            hasBorder={false}
          />
        </SectionCard>
      )}
    </Stack>
  );
};
